export enum MEDIA_TYPE {
  ALL = "ALL",
  PDF = "PDF",
  VIDEO = "VIDEO",
  NEW_PAGE = "NEW_PAGE",
}

export enum CATEGORIES {
  REPORTS = "REPORTS",
  NEWSLETTER = "NEWSLETTER",
  PUBLICATIONS = "PUBLICATIONS",
  COURSES = "COURSES",
  ADVERTORIALS = "ADVERTORIALS",
}

export enum LANGUAGE {
  EN = "EN",
  CH = "CH",
}
export enum ADVERTORIALS_SECTOR {
  OVERVIEW = "OVERVIEW",
  MAINLAND_OPPORTUNITY = "MAINLAND_OPPORTUNITY",
  MANPOWER = "MANPOWER",
  METROLOGY = "METROLOGY",
  TC_SUPPORT = "TC_SUPPORT",
  MANAGEMENT_SYSTEM = "MANAGEMENT_SYSTEM",
  CHINESE_MEDICINE = "CHINESE_MEDICINE",
  CONSTRUCTION = "CONSTRUCTION",
  ELECTRICAL_PRODUCTS = "ELECTRICAL_PRODUCTS",
  ENVIRONMENT_PROTECTION = "ENVIRONMENT_PROTECTION",
  FOOD = "FOOD",
  INFORMATION_TECHNOLOGY = "INFORMATION_TECHNOLOGY",
  JEWELLERY = "JEWELLERY",
  MEDICAL_TESTING = "MEDICAL_TESTING",
  TEXTILE_CLOTHING = "TEXTILE_CLOTHING",
  TOYS = "TOYS",
}

export type PublicationType = {
  title: string;
  titleCN?: string;
  date?: string;
  dateCN?: string;
  link: string;
  scLink?: string;
  tcLink?: string;
  sector?: ADVERTORIALS_SECTOR[];
  mediaType: MEDIA_TYPE;
  yearRange?: number[];
  category: CATEGORIES[];
  thumbnail?: string;
  mediaDomain?: "hkctc" | "youtube" | "cpas-icac" | "hkbedc";
  language?: LANGUAGE;
  external?: boolean;
};

export type CoursesType = Omit<PublicationType, "date" | "mediaType"> & {
  language: LANGUAGE;
};

export const coursesList: CoursesType[] = [
  {
    title:
      "Analysis of Colorants in Food and Personal-Care Products (English Version)",
    link: "/videos/en/STEM_Module_1_Eng.mp4", // https://www.hkctc.gov.hk
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },

  {
    title:
      "Analysis of Colorants in Food and Personal-Care Products (Cantonese Version)",
    link: "/videos/tc/STEM_Module_1_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Screening Test for Plastic Type of Plastic Products (English Version)",
    link: "/videos/en/STEM_Module_2_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Screening Test for Plastic Type of Plastic Products (Cantonese Version)",
    link: "/videos/tc/STEM_Module_2_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Analysis of Bacteria in Environmental Samples (English Version)",
    link: "/videos/en/STEM_Module_3_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Analysis of Bacteria in Environmental Samples (Cantonese Version)",
    link: "/videos/tc/STEM_Module_3_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Wine-Making and Analysis of Alcohol in Beverage (English Version)",
    link: "/videos/en/STEM_Module_4_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Wine-Making and Analysis of Alcohol in Beverage (Cantonese Version)",
    link: "/videos/tc/STEM_Module_4_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Slime-Making and Analysis of Borax in Slime (English Version)",
    link: "/videos/en/STEM_Module_5_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Slime-Making and Analysis of Borax in Slime (Cantonese Version)",
    link: "/videos/tc/STEM_Module_5_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Solar Cell Fabrication and Testing on its Electrical Properties (English Version)",
    link: "/videos/en/STEM_Module_6_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Solar Cell Fabrication and Testing on its Electrical Properties (Cantonese Version)",
    link: "/videos/tc/STEM_Module_6_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of NO2 in Air: Air Pollutant Analysis (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Determination of NO2 in Air: Air Pollutant Analysis (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title: "Analysis of Copper in Wastewater (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "Analysis of Copper in Wastewater (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of SO2 in Dried Food Using Optimized Monier-Williams Method (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Determination of SO2 in Dried Food Using Optimized Monier-Williams Method (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Is the Dairy Product Safe? Gold Nanoparticles as a Visual Detection Tool of Melamine (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "Differentiation of Chinese Herb Danshen from Other Similar Herbs Using Facile Test-Tube Scale Chemical Test Method (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Differentiation of Chinese Herb Danshen from Other Similar Herbs Using Facile Test-Tube Scale Chemical Test Method (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },

  {
    title:
      "Determination of Vitamin C in Commercial Sample and Fresh Fruit Juice by Iodometric Titration (English Version)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp06.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "Determination of Vitamin C in Commercial Sample and Fresh Fruit Juice by Iodometric Titration (Cantonese Version)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp06.mp4.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
];

export const coursesList_cn: CoursesType[] = [
  {
    title: "食品和個人護理產品中的著色劑分析 (英文版本)",
    link: "/videos/en/STEM_Module_1_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "食品和個人護理產品中的著色劑分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_1_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "塑料產品類型的篩選測試 (英文版本)",
    link: "/videos/en/STEM_Module_2_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "塑料產品類型的篩選測試 (粵語版本)",
    link: "/videos/tc/STEM_Module_2_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "環境樣品中的細菌分析 (英文版本)",
    link: "/videos/en/STEM_Module_3_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "環境樣品中的細菌分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_3_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "釀酒與飲料中酒精的分析 (英文版本)",
    link: "/videos/en/STEM_Module_4_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "釀酒與飲料中酒精的分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_4_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "「鬼口水」的製作和「鬼口水」中硼砂成份的分析 (英文版本)",
    link: "/videos/en/STEM_Module_5_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "「鬼口水」的製作和「鬼口水」中硼砂成份的分析 (粵語版本)",
    link: "/videos/tc/STEM_Module_5_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "太陽能電池的製造和電性能測試 (英文版本)",
    link: "/videos/en/STEM_Module_6_Eng.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "太陽能電池的製造和電性能測試 (粵語版本)",
    link: "/videos/tc/STEM_Module_6_Chi.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "空氣中二氧化氮的測試 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "空氣中二氧化氮的測試 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp01.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "分析廢水的含銅量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "分析廢水的含銅量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp02.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以優化「莫尼—威廉」法測試乾糧中的二氧化硫含量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "以優化「莫尼—威廉」法測試乾糧中的二氧化硫含量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp03.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title:
      "這乳製品安全嗎？使用金鈉米粒子「比色探針法」檢測三聚氰胺 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp04.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.EN,
  },
  {
    title: "使用快速試管化學測試法分辨中國草藥丹參與其他類似的草藥 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "使用快速試管化學測試法分辨中國草藥丹參與其他類似的草藥 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp05.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以碘滴定法測試維他命商品和鮮榨果汁的維他命C含量 (英文版本)",
    link: "/videos/en/chemistryhkbueduhkitcDemo-Ehtm_Exp06.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
  {
    title: "以碘滴定法測試維他命商品和鮮榨果汁的維他命C含量 (粵語版本)",
    link: "/videos/tc/chemistryhkbueduhkitcDemo-Chtm_Exp06.mp4.mp4",
    category: [CATEGORIES.COURSES],
    language: LANGUAGE.CH,
  },
];

export const convertedCoursesList: PublicationType[] = coursesList.map((c) => ({
  title: c.title,
  link: c.link,
  mediaType: MEDIA_TYPE.VIDEO,
  category: c.category,
  language: c.language,
}));

export const convertedCoursesList_cn: PublicationType[] = coursesList_cn.map(
  (c) => ({
    title: c.title,
    link: c.link,
    mediaType: MEDIA_TYPE.VIDEO,
    category: c.category,
    language: c.language,
  })
);

export const comicsList: PublicationType[] = [
  {
    title: "第一話 : 講個「信」字？",
    link: "/tc/doc/comic_issue_no_1.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_1.png",
  },
  {
    title: "第二話：我要 check 清楚",
    link: "/tc/doc/comic_issue_no_2.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_2.png",
  },
  {
    title: "第三話：抗菌防臭襪",
    link: "/tc/doc/comic_issue_no_3.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_3.png",
  },
  {
    title: "第四話：生日禮物",
    link: "/tc/doc/comic_issue_no_4.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_4.png",
  },
  {
    title: "第五話：壓力煲風雲",
    link: "/tc/doc/comic_issue_no_5.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_5.png",
  },
  {
    title: "第六話：能源效益測試",
    link: "/tc/doc/comic_issue_no_6.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_6.png",
  },
  {
    title: "第七話：神奇縮水毛衣",
    link: "/tc/doc/comic_issue_no_7.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_7.png",
  },
  {
    title: "第八話：我很大方",
    link: "/tc/doc/comic_issue_no_8.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_8.png",
  },
  {
    title: "第九話：明明都是碟",
    link: "/tc/doc/comic_issue_no_9.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_9.png",
  },
  {
    title: "第十話：手機干擾",
    link: "/tc/doc/comic_issue_no_10.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_10.png",
  },
  {
    title: "第十一話：愈深愈擋光？",
    link: "/tc/doc/comic_issue_no_11.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_11.png",
  },
  {
    title: "第十二話：個磅呃秤？",
    link: "/tc/doc/comic_issue_no_12.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_12.png",
  },
  {
    title: "第十三話：另類測試",
    link: "/tc/doc/comic_issue_no_13.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_13.png",
  },
  {
    title: "第十四話：有機大計",
    link: "/tc/doc/comic_issue_no_14.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_14.png",
  },
  {
    title: "第十五話：紅唇烈焰",
    link: "/tc/doc/comic_issue_no_15.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_15.png",
  },
  {
    title: "第十六話：新裝潢新味道",
    link: "/tc/doc/comic_issue_no_16.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_16.png",
  },
  {
    title: "第十七話：可愛動物裝",
    link: "/tc/doc/comic_issue_no_17.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_17.png",
  },
  {
    title: "第十八話：爸爸忙什麼",
    link: "/tc/doc/comic_issue_no_18.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_18.png",
  },
  {
    title: "第十九話：超軟床褥",
    link: "/tc/doc/comic_issue_no_19.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_19.png",
  },
  {
    title: "第二十話：試造新衫",
    link: "/tc/doc/comic_issue_no_20.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_20.png",
  },
  {
    title: "第二十一話：返工就打噴嚏？",
    link: "/tc/doc/comic_issue_no_21.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_21.png",
  },
  {
    title: "第二十二話：自製冰袋",
    link: "/tc/doc/comic_issue_no_22.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_22.png",
  },
  {
    title: "第二十三話：遙控機械人",
    link: "/tc/doc/comic_issue_no_23.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_23.png",
  },
  {
    title: "第二十四話：鑽的疑惑",
    link: "/tc/doc/comic_issue_no_24.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_24.png",
  },
  {
    title: "第二十五話：香味專家",
    link: "/tc/doc/comic_issue_no_25.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_25.png",
  },
  {
    title: "第二十六話：各有所好",
    link: "/tc/doc/comic_issue_no_26.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_26.png",
  },
  {
    title: "第二十七話：試食曲奇",
    link: "/tc/doc/comic_issue_no_27.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_27.png",
  },
  {
    title: "第二十八話：奪命喊聲",
    link: "/tc/doc/comic_issue_no_28.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_28.png",
  },
  {
    title: "第二十九話：深宵驚魂",
    link: "/tc/doc/comic_issue_no_29.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_29.png",
  },
  {
    title: "第三十話：學生模範",
    link: "/tc/doc/comic_issue_no_30.pdf",
    mediaType: MEDIA_TYPE.PDF,
    category: [CATEGORIES.PUBLICATIONS],
    thumbnail: "publications/comics/comics_30.png",
  },
];
